import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { MentoringProgramActionItemTemplate, TemplateAssignedRole } from 'redux/schemas/models/mentoring-program-action-item-templates';

type TemplateBody = {
  description: string;
  assignedRole: TemplateAssignedRole;
  required: boolean;
};

type GetTemplatesParams = {
  mentoringProgramId: number;
};

type CreateTemplateParams = {
  mentoringProgramId: number;
  mentorshipProgramActionItemTemplate: TemplateBody;
};

type UpdateTemplateParams = CreateTemplateParams & {
  templateId: number;
};

type DeleteTemplateParams = GetTemplatesParams & {
  templateId: number;
};

export const getMentorshipProgramActionItemTemplates = createAsyncThunk<MentoringProgramActionItemTemplate[], GetTemplatesParams>(
  'GET_MENTORSHIP_PROGRAM_ACTION_ITEM_TEMPLATES',
  async ({ mentoringProgramId }) => {
    const response = await axios.get(
      `/mentorship_programs/${mentoringProgramId}/action_item_templates.json`,
    );
    return response.data.result.actionItemTemplates as MentoringProgramActionItemTemplate[];
  },
);

export const createMentorshipProgramActionItemTemplate = createAsyncThunk<MentoringProgramActionItemTemplate, CreateTemplateParams>(
  'CREATE_MENTORSHIP_PROGRAM_ACTION_ITEM_TEMPLATE',
  async ({ mentoringProgramId, mentorshipProgramActionItemTemplate }) => {
    const response = await axios.post(
      `/mentorship_programs/${mentoringProgramId}/action_item_templates.json`,
      { mentorshipProgramActionItemTemplate },
    );
    return response.data.result as MentoringProgramActionItemTemplate;
  },
);

export const updateMentorshipProgramActionItemTemplate = createAsyncThunk<MentoringProgramActionItemTemplate, UpdateTemplateParams>(
  'UPDATE_MENTORSHIP_PROGRAM_ACTION_ITEM_TEMPLATE',
  async ({ mentoringProgramId, templateId, mentorshipProgramActionItemTemplate }) => {
    const response = await axios.put(
      `/mentorship_programs/${mentoringProgramId}/action_item_templates/${templateId}.json`,
      { mentorshipProgramActionItemTemplate },
    );
    return response.data.result as MentoringProgramActionItemTemplate;
  },
);

export const deleteMentorshipProgramActionItemTemplate = createAsyncThunk<void, DeleteTemplateParams>(
  'DELETE_MENTORSHIP_PROGRAM_ACTION_ITEM_TEMPLATE',
  async ({ mentoringProgramId, templateId }) => {
    await axios.delete(
      `/mentorship_programs/${mentoringProgramId}/action_item_templates/${templateId}.json`,
    );
  },
);
